import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(12px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const StatsSection = styled.div`
  background-color: var(--primary-color);
  padding: 3rem 2rem;
`;

const StatsGrid = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;

  @media (min-width: 640px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;

const StatItem = styled.div`
  text-align: center;
  animation: ${fadeUp} 0.6s ease-out both;
  animation-delay: ${props => props.$index * 0.1}s;
`;

const StatNumber = styled.div`
  font-size: 2.25rem;
  font-weight: 800;
  color: #f8fafc;
  line-height: 1;
  margin-bottom: 0.4rem;

  span {
    color: #60a5fa;
  }
`;

const StatLabel = styled.div`
  font-size: 0.85rem;
  color: #94a3b8;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

const stats = [
  { number: '3', suffix: '+', label: 'Years Experience' },
  { number: '3', suffix: '', label: 'Companies' },
  { number: '20', suffix: '+', label: 'Enterprise Clients' },
  { number: '99.9', suffix: '%', label: 'Uptime Delivered' },
];

const Stats = () => (
  <StatsSection>
    <StatsGrid>
      {stats.map((stat, i) => (
        <StatItem key={stat.label} $index={i}>
          <StatNumber>
            {stat.number}<span>{stat.suffix}</span>
          </StatNumber>
          <StatLabel>{stat.label}</StatLabel>
        </StatItem>
      ))}
    </StatsGrid>
  </StatsSection>
);

export default Stats;
